//  React Imports
import React, { useContext } from "react";

/**
 *  Material-UI Imports
 */
import Hidden from "@material-ui/core/Hidden";
import Box from "@material-ui/core/Box";

/**
 *  Component Imports
 */
import AppFixedFooter from "./AppFixedFooter";
import AppHeader from "./AppHeader";
import AppSidebar from "./AppSidebar";
import useStyles from "./index.style";
import { ContentView } from "../../../index";

/**
 *  Node Module Imports
 */
import clsx from "clsx";

/**
 *  Utiltiy Imports
 */
import { LayoutType } from "shared/constants/AppEnums";
import AppContext from "../../../utility/AppContext";

/**
 *  Material-UI Imports
 */
const StandardLayout = (props) => {
  const classes = useStyles(props);
  const { footer, layoutType, footerType } = useContext(AppContext);

  return (
    <Box
      className={clsx(
        classes.appMain,
        layoutType === LayoutType.BOXED ? classes.boxedLayout : "",
        {
          appMainFooter: footer && footerType === "fluid",
          appMainFixedFooter: footer && footerType === "fixed",
        }
      )}
    >
      <AppSidebar />

      <Box className={classes.mainContent}>
        <Hidden mdDown>
          <Box className={classes.mainContainer}>
            <AppHeader />
            <ContentView />
            <AppFixedFooter />
          </Box>
        </Hidden>

        <Hidden lgUp>
          <Box className={classes.mainContainerFull}>
            <AppHeader />
            <ContentView />
            <AppFixedFooter />
          </Box>
        </Hidden>
      </Box>
    </Box>
  );
};

export default StandardLayout;
